export default __webpack_public_path__ + "static/lines_mobile-0ce084eb5dd56e11d744d89a0dfbe0ac.svg";